
export const RequisasMaterialesReporteLang = {
  // ENCABEZADO
  requisaM: {
    es: "Requisa Materiales",
    en: "Materials Requisition",
  },
  requisaMP: {
    es: "Requisa de Materia Prima",
    en: "Raw Material Requisition",
  },
  fecha: {
    es: "Fecha: ",
    en: "Date: ",
  },
  area: {
    es: "Área: ",
    en: "Area: ",
  },
  requisitos: {
    es: "Requerimientos de Despacho",
    en: "Dispatch Requirements",
  },
  // creadoPor: {
  //   es: "Creado Por: ",
  //   en: "Created By: ",
  // },
  solicita: {
    es: "Solícita: ",
    en: "Request: ",
  },

  // TABLA
  estado: {
    es: "ESTADO",
    en: "STATUS",
  },
  fechaTabla: {
    es: "FECHA",
    en: "DATE",
  },
  estente: {
    es: "ESTANTE",
    en: "SHELF",
  },
  posicion: {
    es: "POSICIÓN",
    en: "POSITION",
  },
  bandeja: {
    es: "BANDEJA",
    en: "TRAY",
  },
  codigo: {
    es: "CÓDIGO",
    en: "CODE",
  },
  producto: {
    es: "PRODUCTO",
    en: "PRODUCT",
  },
  asignacion: {
    es: "ASIGNACIÓN",
    en: "ASSIGNMENT",
  },
  maquina: {
    es: "MÁQUINA / EQUIPO",
    en: "MACHINE / EQUIPMENT",
  },
  cantidad: {
    es: "CANTIDAD",
    en: "QUANTITY",
  },
//   unidad: {
//     es: "UNIDAD",
//     en: "UNIT",
//   },
//   moneda: {
//     es: "MONEDA",
//     en: "CURRENCY",
//   },
//   precio: {
//     es: "PRECIO",
//     en: "PRICE",
//   },
//   isv: {
//     es: "ISV",
//     en: "TAX",
//   },
//   descuento: {
//     es: "DESC.",
//     en: "DISC.",
//   },
  comentario: {
    es: "Comentario.",
    en: "Comment.",
  },
//   detallesEn: {
//     es: "Detalles en ",
//     en: "Details in ",
//   },

  // FIRMAS
  firmaAutoriza: {
    es: "Autoriza",
    en: "Authorize",
  },
  tecnico: {
    es: "Técnico",
    en: "Technical",
  },
  bodega: {
    es: "Bodega",
    en: "Werehouse",
  },
  recibidoPor: {
    es: "Recibido Por",
    en: "Received by",
  },

  // FOOTER
  // fechaImpresion: {
  //   es: "Fecha de Impresión: ",
  //   en: "Printing Date: ",
  // },
  // original: {
  //   es: "Original: Cliente",
  //   en: "Original: Client ",
  // },
  // copia: {
  //   es: "Copia: Contabilidad",
  //   en: "Copy: Accounting ",
  // },
  Pagina: {
    es: "Página",
    en: "Page",
  },
};